/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { isEqual } from 'lodash'

import { get } from 'services/api'
import { Pagination } from 'components'
import ManualAnalysisSearchBar from 'components/ManualAnalysisSearchBar'
import ReviewTable from 'components/ReviewTable'
import ExportButton from 'components/ExportButton'
import { Scopes } from 'utils/authUtils'
import ForbiddenAccessAlert from '../../components/ForbiddenAccessAlert'

import styles from './styles'

const ManualAnalysisAuditContent = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(false)
  const [reviews, setReviews] = useState(null)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [itemsNumber, setItemsNumber] = useState(1)
  const [searchParams, setSearchParams] = useState({})

  useEffect(() => {
    getData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, searchParams])

  const getData = async () => {
    setLoading(true)

    const res = await get({
      url: `/reviews/paginated`,
      params: { ...searchParams, page: page + 1, size: size },
      token,
    })

    if (res) {
      setReviews(res?.items)
      setItemsNumber(res?.total)
    } else {
      setReviews([])
      setItemsNumber(0)
    }

    setLoading(false)
  }


  const handleChangeSearchParams = (value) => {
    if (!isEqual(searchParams, value)) {
      setPage(0)
      setSearchParams(value)
    }
  }

  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setPage(0)
  }

  const reloadData = () => {
    getData()
  }

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
        <ManualAnalysisSearchBar
          setSearchParams={handleChangeSearchParams}
        />
        <ExportButton
          url="/reviews/export"
          searchParams={searchParams}
          filename="lista-reviews-background-check"
        />
      </div>

      {loading ? (
        <div className={classes.loading}>
          <CircularProgress size={64} color="primary" />
          <span className={classes.loadingText}>Buscando aplicações...</span>
        </div>
      ) : (
        <React.Fragment>
          <div className={classes.tableContainer}>
            <ReviewTable
              reviews={reviews}
              reloadData={reloadData}
            />
          </div>
          {reviews?.length > 0 && (
            <Pagination
              count={itemsNumber}
              component="div"
              page={page}
              rowsPerPage={size}
              rowsPerPageOptions={[10, 15, 20, 25, 30]}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </React.Fragment>
      )}
    </div>
  )
}

const ManualAnalysisAudit = () => (
  <ForbiddenAccessAlert
    requriedScopes={[Scopes.REVIEW_LIST]}
    screenName="Lista de Revisões Manuais"
  >
    <ManualAnalysisAuditContent />
  </ForbiddenAccessAlert>
)

export default ManualAnalysisAudit
